import React from 'react';
import  JuniorAssociation2025  from 'views/JuniorAssociation2025';
const BlogNewsroomPage = () => {
return <JuniorAssociation2025/>
};
export default BlogNewsroomPage;